import { createFileRoute } from "@tanstack/react-router";
import { AiChatFeedbacks } from "@/components/AiChatFeedbacks";

function RouteComponent() {
  return <AiChatFeedbacks />;
}

export const Route = createFileRoute("/_authenticated/feedbacks/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
